// extracted by mini-css-extract-plugin
export default {"price_container":"Prices_price_container__ui7I+","price_title":"Prices_price_title__C81LM","amount_container":"Prices_amount_container__udSZc"};